export let StudyPurpose = /*#__PURE__*/function (StudyPurpose) {
  StudyPurpose["MAIN_STUDY"] = "main_study";
  StudyPurpose["DESCRIPTION"] = "description";
  return StudyPurpose;
}({});
export let IndexName = /*#__PURE__*/function (IndexName) {
  IndexName["ALL"] = "\uC804\uCCB4";
  return IndexName;
}({});
export let WeekDay = /*#__PURE__*/function (WeekDay) {
  WeekDay["MONDAY"] = "MONDAY";
  WeekDay["TUESDAY"] = "TUESDAY";
  WeekDay["WEDNESDAY"] = "WEDNESDAY";
  WeekDay["THURSDAY"] = "THURSDAY";
  WeekDay["FRIDAY"] = "FRIDAY";
  WeekDay["SATURDAY"] = "SATURDAY";
  WeekDay["SUNDAY"] = "SUNDAY";
  return WeekDay;
}({});
export let StudyReportType = /*#__PURE__*/function (StudyReportType) {
  StudyReportType["DAILY_REPORT"] = "DAILY_STUDY_RESULT";
  StudyReportType["WEEKLY_REPORT"] = "WEEKLY_STUDY_RESULT";
  return StudyReportType;
}({});
export let ReportContentType = /*#__PURE__*/function (ReportContentType) {
  ReportContentType["STUDY_TIME"] = "studyTime";
  ReportContentType["STUDY_RECORD"] = "studyRecord";
  ReportContentType["ON_GOING_COURSE"] = "ongoingCourse";
  ReportContentType["TEST_RECORD"] = "testRecord";
  return ReportContentType;
}({});
export let RecipientType = /*#__PURE__*/function (RecipientType) {
  RecipientType["PARENT"] = "PARENT";
  RecipientType["STUDENT"] = "STUDENT";
  RecipientType["UNKNOWN"] = "UNKNOWN";
  return RecipientType;
}({});
export let CreditType = /*#__PURE__*/function (CreditType) {
  CreditType["WEEKLY_ASSIGNMENT_PROGRESS_OVER_90"] = "WEEKLY_ASSIGNMENT_PROGRESS_OVER_90";
  CreditType["WEEKLY_ELAPSED_TIME_OVER_15H"] = "WEEKLY_ELAPSED_TIME_OVER_15H";
  CreditType["PASS_WEEKLY_WRONG_TEST"] = "PASS_WEEKLY_WRONG_TEST";
  CreditType["DAILY_RANK_TOP_10"] = "DAILY_RANK_TOP_10";
  CreditType["WEEKLY_RANK_TOP_10"] = "WEEKLY_RANK_TOP_10";
  CreditType["MONTHLY_RANK_TOP_10"] = "MONTHLY_RANK_TOP_10";
  CreditType["DAILY_ELAPSED_TIME_OVER_3H"] = "DAILY_ELAPSED_TIME_OVER_3H";
  CreditType["EXCELLENT_STUDY_ATTITUDE"] = "EXCELLENT_STUDY_ATTITUDE";
  CreditType["PERFECT_ATTENDANCE_MONTH"] = "PERFECT_ATTENDANCE_MONTH";
  CreditType["HIGH_SCORE_ON_SCHOOL_EXAM"] = "HIGH_SCORE_ON_SCHOOL_EXAM";
  CreditType["RAPID_SCORE_IMPROVEMENT"] = "RAPID_SCORE_IMPROVEMENT";
  CreditType["DAILY_ASSIGNMENT_PROGRESS_UNDER_80"] = "DAILY_ASSIGNMENT_PROGRESS_UNDER_80";
  CreditType["LATE_OVER_30M"] = "LATE_OVER_30M";
  CreditType["ABSENCE_NOTICE_TODAY"] = "ABSENCE_NOTICE_TODAY";
  CreditType["UNEXCUSED_ABSENCE"] = "UNEXCUSED_ABSENCE";
  CreditType["NO_RESPONSE_OVER_20M"] = "NO_RESPONSE_OVER_20M";
  CreditType["NON_STUDY_ACTIVITY"] = "NON_STUDY_ACTIVITY";
  CreditType["INSINCERE_STUDY_ATTITUDE"] = "INSINCERE_STUDY_ATTITUDE";
  CreditType["INAPPROPRIATE_BEHAVIOR_OR_LANGUAGE"] = "INAPPROPRIATE_BEHAVIOR_OR_LANGUAGE";
  CreditType["FAIL_WEEKLY_WRONG_TEST"] = "FAIL_WEEKLY_WRONG_TEST";
  CreditType["EXCHANGE"] = "EXCHANGE";
  CreditType["ETC"] = "ETC";
  return CreditType;
}({});
export let Grade = /*#__PURE__*/function (Grade) {
  Grade["PRIMARY1"] = "\uCD081";
  Grade["PRIMARY2"] = "\uCD082";
  Grade["PRIMARY3"] = "\uCD083";
  Grade["PRIMARY4"] = "\uCD084";
  Grade["PRIMARY5"] = "\uCD085";
  Grade["PRIMARY6"] = "\uCD086";
  Grade["MIDDLE1"] = "\uC9111";
  Grade["MIDDLE2"] = "\uC9112";
  Grade["MIDDLE3"] = "\uC9113";
  Grade["HIGH1"] = "\uACE01";
  Grade["HIGH2"] = "\uACE02";
  Grade["HIGH3"] = "\uACE03";
  Grade["NTH"] = "N\uC218\uC0DD";
  Grade["ETC"] = "\uAE30\uD0C0";
  return Grade;
}({});
export let LoginPageType = /*#__PURE__*/function (LoginPageType) {
  LoginPageType["PARENTS"] = "parents";
  LoginPageType["NORMAL"] = "normal";
  return LoginPageType;
}({});